<mat-dialog-content>
    <div class="info-section">
        <div class="info-icon">i</div>
        <div>
            Manulane rozliczeniue klienta. Podaj okres rozliczenia i wprowadź nowy okres rozliczeniowy. Gdy dla danego
            klienta istnieją raporty poza okresem rozliczenia zostaną one przypisane do nowego okresu rozliczeniowego
        </div>
    </div>
    <hr class="section-separator" />

    <div class="section-title">Okres rozliczeniua</div>
    <div class="date-row">
        <mat-form-field class="date-field">
            <mat-label>od</mat-label>
            <input matInput [matDatepicker]="billingFromPicker" [(ngModel)]="billingPeriodFrom" [disabled]="true" />
            <mat-datepicker-toggle matSuffix [for]="billingFromPicker" [disabled]="true"></mat-datepicker-toggle>
            <mat-datepicker #billingFromPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="date-field">
            <mat-label>do</mat-label>
            <input matInput [matDatepicker]="billingToPicker" [(ngModel)]="billingPeriodTo" [max]="today" />
            <mat-datepicker-toggle matSuffix [for]="billingToPicker"></mat-datepicker-toggle>
            <mat-datepicker #billingToPicker></mat-datepicker>
            @if (errors.billingPeriodTo) {
                <mat-error>{{ errors.billingPeriodTo }}</mat-error>
            }
        </mat-form-field>
    </div>

    <div class="section-title">Nowy okres rozliczeniowy</div>
    <div class="date-row">
        <mat-form-field class="date-field">
            <mat-label>od</mat-label>
            <input matInput [matDatepicker]="newBillingFromPicker" [(ngModel)]="newBillingPeriodFrom" [min]="billingPeriodTo" />
            <mat-datepicker-toggle matSuffix [for]="newBillingFromPicker"></mat-datepicker-toggle>
            <mat-datepicker #newBillingFromPicker></mat-datepicker>
            @if (errors.newBillingPeriodFrom) {
                <mat-error>{{ errors.newBillingPeriodFrom }}</mat-error>
            }
        </mat-form-field>
        <mat-form-field class="date-field">
            <mat-label>do</mat-label>
            <input matInput [matDatepicker]="newBillingToPicker" [(ngModel)]="newBillingPeriodTo" [min]="newBillingPeriodFrom" />
            <mat-datepicker-toggle matSuffix [for]="newBillingToPicker"></mat-datepicker-toggle>
            <mat-datepicker #newBillingToPicker></mat-datepicker>
            @if (errors.newBillingPeriodTo) {
                <mat-error>{{ errors.newBillingPeriodTo }}</mat-error>
            }
        </mat-form-field>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" style="margin-top: 24px;">
    <button matButton (click)="closeDialog()">Anuluj</button>
    <button mat-flat-button color="primary" cdkFocusInitial (click)="settle()" [disabled]="!isValid()">Rozlicz</button>
</mat-dialog-actions>
